var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{attrs:{"viewPermission":_vm.viewPermission,"createPermission":_vm.createPermission,"editPermission":_vm.editPermission,"deletePermission":_vm.deletePermission}})
}
var staticRenderFns = []

export { render, staticRenderFns }